import { RolesDetailsDTO } from "./RolesDetailsDTO";

export class LogOutDTO {
    "emailId": string;
    "lanId": any;
    "racfId": any;
    "firstName": string;
    "lastName": string;
    "sessionDetails": SessionDetailsDTO;
    "client": ClientDetailsDTO[];
    "rolesDetails": RolesDetailsDTO[];
    "customerSessionList": any[];
    "clientId": string;
    "serviceName": string;
    "urlPattern": string;
    "apiVersion": string;
    "geneSysUserId": string;
}


export class SessionDetailsDTO {
    sessionId: any;
    lastaccessedTimestamp: any;
}

export class ClientDetailsDTO {
    "clientId": string;
    "clientName": string;
    "firstName": string;
    "lastName": string;
    "personId": string;
    "personinternalId": string;
    "employeeId": string;
    "udpId": string;
    "clientInformation": string;
    "customerSessionId": string;
    "callerType": string;
    "livecallStatus": string;
    "callstartTime": string;
    "callendTime": string;
    "callMode": string;

}